import { useState, useEffect } from 'react';
import { api } from '../api.js';
import Spinner from '../components/Spinner.jsx';

const STATUS_OPTS = [
  { value: 'open',     label: 'Offen',      cls: 'bg-coral-100 text-coral-600' },
  { value: 'reviewed', label: 'Geprüft',    cls: 'bg-amber-100 text-amber-700' },
  { value: 'resolved', label: 'Erledigt',   cls: 'bg-teal-100 text-teal-700' },
];

const TYPE_LABEL = { question: 'Frage', lernreihe_step: 'Lernreihe-Schritt', other: 'Sonstiges' };

export default function Reports() {
  const [filter, setFilter]     = useState('open');
  const [reports, setReports]   = useState([]);
  const [loading, setLoading]   = useState(true);
  const [resolving, setResolving] = useState(null);
  const [resolution, setResolution] = useState({});

  const load = (status) => {
    setLoading(true);
    api.getReports(status)
      .then((d) => setReports(d.reports))
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(filter); }, [filter]);

  const update = async (id, status) => {
    setResolving(id);
    try {
      await api.updateReport(id, { status, resolution: resolution[id] });
      load(filter);
      setResolution((r) => { const c = { ...r }; delete c[id]; return c; });
    } catch (e) { alert(e.message); }
    finally { setResolving(null); }
  };

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <h1 className="text-xl font-bold text-gray-900">Meldungen</h1>
        <div className="flex gap-1 ml-auto">
          {STATUS_OPTS.map((s) => (
            <button key={s.value}
              onClick={() => setFilter(s.value)}
              className={`text-xs px-3 py-1 rounded-full font-medium transition-colors ${filter === s.value ? s.cls : 'bg-gray-100 text-gray-500 hover:bg-gray-200'}`}>
              {s.label}
            </button>
          ))}
        </div>
      </div>

      {loading && <div className="flex justify-center py-12"><Spinner size="lg" /></div>}

      {!loading && reports.length === 0 && (
        <div className="card text-center py-10 text-gray-500 text-sm">Keine Meldungen gefunden.</div>
      )}

      {!loading && reports.map((r) => (
        <div key={r.id} className="card space-y-3">
          <div className="flex items-start justify-between gap-3">
            <div className="space-y-0.5">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                  {TYPE_LABEL[r.type] ?? r.type}
                </span>
                <span className="font-mono text-xs text-ocean-500 bg-ocean-50 px-2 py-0.5 rounded">
                  {r.ref_id}
                </span>
              </div>
              <p className="font-semibold text-gray-900 text-sm">{r.reason}</p>
              {r.detail && <p className="text-xs text-gray-600">{r.detail}</p>}
              <p className="text-xs text-gray-400">
                Von {r.reporter} · {new Date(r.reported_at).toLocaleString('de-DE')}
              </p>
            </div>
            <span className={`badge shrink-0 ${STATUS_OPTS.find((s) => s.value === r.status)?.cls ?? ''}`}>
              {STATUS_OPTS.find((s) => s.value === r.status)?.label ?? r.status}
            </span>
          </div>

          {r.status === 'open' && (
            <div className="pt-2 border-t border-gray-100 space-y-2">
              <textarea className="input text-xs" rows={2}
                placeholder="Notiz zur Entscheidung (optional)"
                value={resolution[r.id] ?? ''}
                onChange={(e) => setResolution((prev) => ({ ...prev, [r.id]: e.target.value }))} />
              <div className="flex gap-2">
                <button onClick={() => update(r.id, 'reviewed')} disabled={resolving === r.id}
                  className="btn-secondary text-xs">Als geprüft markieren</button>
                <button onClick={() => update(r.id, 'resolved')} disabled={resolving === r.id}
                  className="btn-primary text-xs">Erledigt</button>
              </div>
            </div>
          )}
          {r.resolution && (
            <p className="text-xs text-gray-500 border-t border-gray-100 pt-2">
              <strong>Notiz:</strong> {r.resolution}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}
